import { UploadedFileInterface } from './types';

export default class UploadedFile implements UploadedFileInterface {
  file: File;
  id: string;
  name: string;
  url: string;
  progress: number | null;
  type: string;
  size: number;

  constructor(file: File) {
    this.file = file;
    this.id = `${file.name}-${file.size}-${file.lastModified}-${file.type}`;
    this.name = file.name;
    this.url = URL.createObjectURL(file);
    this.progress = null;
    this.type = file.type;
    this.size = file.size;
  }

  public async getDuration(): Promise<number> {
    if (!this.type.includes('video')) {
      return 0;
    }

    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = this.url;
      video.onloadedmetadata = () => {
        const duration = video.duration;
        URL.revokeObjectURL(video.src);
        resolve(duration);
      };
    });
  }

}
